export const getWidth = (): string => {
  if (document.documentElement && document.documentElement.clientHeight) {
    return String(document.documentElement.clientWidth);
  }

  if (document.body) {
    return String(document.body.clientWidth);
  }

  return '0';
};

export const getHeight = (): string => {
  if (document.documentElement && document.documentElement.clientHeight) {
    return String(document.documentElement.clientHeight);
  }

  if (document.body) {
    return String(document.body.clientHeight);
  }

  return '0';
};

export const getHostname = () => {
  return (window.location || {}).hostname || '';
};

export const getCurrentSRC = () => {
  return window.location.href;
};
